import RecipeContext from "./store/recipe-context";
import { useContext } from "react";
import css from "./name.module.css";
import Section from "./section";

function Name() {
  const recipeContext = useContext(RecipeContext);

  function onChange(event) {
    recipeContext.updateName(event.target.value);
    recipeContext.updateMissingParts(event.target.value);
  }

  return (
    <Section sectionStyle="small">
      <input
        id="reipce_Name"
        className={`${css.input} ${
          recipeContext.missingParts ? css.errorBorder : null
        }`}
        defaultValue={recipeContext.name}
        placeholder={"Enter Recipe Name"}
        onChange={onChange}
      />
      {recipeContext.missingParts ? (
        <p className={css.p}>* ENTER NAME</p>
      ) : null}
    </Section>
  );
}

export default Name;
